var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"BFXNZDktMu1rW7kQ3zrI2"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import { replayIntegration } from '@sentry/replay';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  sendDefaultPii: true,
  tags: { 'app.runtime': 'client' },
  tracesSampleRate: 0.1, // Adjust this value (0.0 to 1.0)
  environment: 'shop', // Or 'admin' if this is your admin app
  integrations: [
    replayIntegration(),
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation, // <--- CHANGE THIS LINE
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
